import { render, staticRenderFns } from "./Elements.vue?vue&type=template&id=38d20e2c&"
import script from "./Elements.vue?vue&type=script&lang=ts&"
export * from "./Elements.vue?vue&type=script&lang=ts&"
import style0 from "./Elements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports